import { Button, TableCellLayout } from '@fluentui/react-components'
import { AppGeneric24Filled, AppGeneric24Regular } from '@fluentui/react-icons'
import { useSearchParams } from 'react-router-dom'
import { RestSchemas } from '@/contexts/QueryProvider'

type MessagesApplicationsApplication = RestSchemas['Messages.Applications.Application']

export function AppNameAndButton({ item }: { item: MessagesApplicationsApplication }) {
  const [searchParams, setSearchParams] = useSearchParams()
  return (
    <TableCellLayout
      media={
        <Button
          appearance="subtle"
          size="large"
          icon={
            item.registered ? (
              <AppGeneric24Filled className="icon-button" color="#D04A02" />
            ) : (
              <AppGeneric24Regular className="icon-button" color="#D1D1D1" />
            )
          }
          onClick={() => {
            searchParams.set('tab', 'details')
            searchParams.set('appId', item.applicationId.toString())
            searchParams.set('appName', item.appName)
            setSearchParams(searchParams)
          }}
        />
      }
    >
      <div
        style={{
          flexDirection: 'column',
          display: 'flex',
          paddingTop: '.5rem',
          paddingBottom: '.5rem',
          gap: '5px',
          lineHeight: '1rem',
        }}
      >
        <span style={{ fontSize: '16px' }}>{item.appName}</span>
        <span style={{ color: '#979797', fontSize: 'small' }}>{item.description}</span>
      </div>
    </TableCellLayout>
  )
}
